import { connect } from 'react-redux';
import Sidebar from '../components/Sidebar';

const mapStateToProps = ({ appInfo: { lastSyncDate } }) => ({
  lastSyncDate,
});

export default connect(mapStateToProps)(Sidebar);
